import DataService from "@/services/DataService.js";
import moment from "moment";

export default {
  fetch(orderid) {
    return DataService.apiClient.get("/order/" + orderid);
  },
  fetchAll(userid = null, filter = null) {
    if (userid) {
      return DataService.apiClient.get("/order/" + userid);
    } else if (filter) {
      return DataService.apiClient.post("/order/filter/", filter);
    } else {
      return DataService.apiClient.get("/order");
    }
  },

  fetchFees(month = null, year) {
    let currentDate = moment();
    let url = `/stats/orderFees?`;
    if (month) {
      currentDate.month(month);
      url = `${url}month=${currentDate.month()}`;
    }
    if (year) {
      currentDate.year(year);
      url = `${url}${month === null ? "" : "&"}year=${currentDate.year()}`;
    }

    return DataService.apiClient.get(url);
  },
  fetchExport(filter = null) {
    return DataService.apiClient.post("/order/export/", filter, {
      responseType: "blob"
    });
  },
  exportToSLA(filter = null) {
    return DataService.apiClient.post("/order/slaexport", filter);
  },
  saveOrder(order) {
    if (order.id != null) {
      return DataService.apiClient.patch("/order/" + order.id, order);
    } else {
      return DataService.apiClient.post("/order/", order);
    }
  },
  updateStatus(id, status) {
    return DataService.apiClient.patch("/order/updateStatus/" + id, { status });
  },

  delete(id) {
    return DataService.apiClient.delete("/order/delete/" + id);
  }
};
